<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
      <div class="box">
        <h3 class="title">Bienvenido a SATRIFO</h3>
        <div class="container_close">
          <a style="margin: auto;" href="https://www.fan-bo.org" target="_blank" rel="noopener noreferrer"><img src="../../../assets/logo_fan.png" style="display: grid; margin:auto; height:80px;" alt="Fundación Amigos de la Naturaleza" title="Fundación Amigos de la Naturaleza"/></a>
          <a style="margin: auto;" href="https://incendios.fan-bo.org/Satrifo/" target="_blank" rel="noopener noreferrer"><img src="../../../assets/logo_satrifo.png" style="display: grid; margin:auto; height:70px;" alt="SATRIFO" title="SATRIFO"/></a>
        </div>
        <p class="intro mt-5">
          El Sistema de monitoreo y alerta temprana de riesgos de incendios forestales (SATRIFO) tiene la finalidad de
          brindar información útil y oportuna para la prevención y control de incendios forestales en Bolivia.
          SATRIFO ofrece información y herramientas dinámicas e interactivas, que permiten visualizar, consultar,
          analizar y descargar mapas y datos históricos y en tiempo casi real para diferentes regiones de Bolivia.</p>
        <label class="checkbox">
          <input type="checkbox" v-model="check" >
          Estoy de acuerdo con los <a href="./terminos.html" target="_blank" rel="noopener noreferrer">terminos y condiciones</a>
        </label>
        <div>
          <button @click = "clickAccept" class="button is-success mt-5 mb-5">Aceptar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as LocalStorage from '@/helpers/localstorage';

export default {
  name: "DialogDisclaimer",
  data() {
    return {
      check: false,
    }
  },
  methods: {
    clickAccept: function() {
      if(!this.check) {
        return;
      }
      LocalStorage.setDisclaimer(true);
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.title {
  margin: 0px auto;
  text-align: left;
}

.intro {
  font-size: 1.125rem;
  font-weight: 300;
  margin-bottom: 1.875rem;
}

.container_close {
  display: grid;
  grid-template-columns: 1fr 1fr .3fr;
  grid-gap: 10px;
  width: 100%;
  height: 100%;
  max-height: 70px;
}

</style>